import id from '@/helpers/id'
import {dreamsCollection} from '@/firebase/data'
import {currentUserId, storage} from '@/firebase/firebase'
import {timestamp} from '@/firebase/firebaseHelpers'


const dreamDefaults = () => {
  return {
    title: null,
    subtitle: null,
    img: null,
    category: null,
    order: 0,
    whyDescription: null,
    gainDescription: null,
    riskDescription: null,
  }
}


export default {
  FETCH_DREAMS ({ commit }) {
    return new Promise((resolve, reject) => {
      dreamsCollection.where('uid', '==', currentUserId()).get()
        .then((docs) => {
          const dreamsArray = []
          docs.forEach(doc => {
            const dream = doc.data()
            dream.id = doc.id
            dream.progress = dream.progress || 0
            dream.order = dream.order || 0
            dream.subtitle = dream.subtitle || ''
            dream.whyDescription = dream.whyDescription || ''
            dream.gainDescription = dream.gainDescription || ''
            dream.riskDescription = dream.riskDescription || ''
            dream.img = dream.img || ''
            dream.category = dream.category || 'other'

            dreamsArray.push(dream)
          })
          commit('SET_DREAMS', dreamsArray)
          resolve(dreamsArray)
        })
        .catch((error) => { reject(error) })
    })
  },
  ADD_DREAM ({ commit }, { dream }) {
    const newDream = Object.assign(dreamDefaults(), dream, {
      uid: currentUserId(),
      createdAt: timestamp()
    })
    return new Promise((resolve, reject) => {
      dreamsCollection.add(newDream)
        .then((response) => {
          commit('ADD_DREAM', Object.assign(newDream, { id: response.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  UPDATE_DREAM ({ commit }, { dream, remote = false }) {
    if (!remote) dream.updatedAt = timestamp()
    if (!dream.completedAt && dream.progress >= 100) {
      dream.completedAt = timestamp()
    } else if (dream.completedAt && dream.progress < 100) {
      dream.completedAt = null
    }
    return new Promise((resolve, reject) => {
      dreamsCollection.doc(dream.id).set(dream)
        .then((response) => {
          if (!remote) commit('UPDATE_DREAM', dream)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  async UPDATE_DREAM_ORDER ({ dispatch }, { dream, order }) {
    const newDream = Object.assign({}, dream, { order })
    await dispatch('UPDATE_DREAM', { dream: newDream, remote: true })
  },
  DELETE_DREAM ({ commit }, { dream }) {
    return new Promise((resolve, reject) => {
      dreamsCollection.doc(dream.id).delete()
        .then((response) => {
          commit('DELETE_DREAM', dream)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  // eslint-disable-next-line
  UPLOAD_DREAM_IMAGE ({ }, { file, dream }) {
    return new Promise((resolve, reject) => {
      if (!file) throw new Error('UPLOAD_DREAM_IMAGE: missing file')

      const refPath = `dreams/${currentUserId()}/${id()}`
      storage.ref(refPath).put(file)
        .then(async (snapshot) => {
          const imageUrl = await snapshot.ref.getDownloadURL()
          resolve(imageUrl)
        })
        .catch((error) => { reject(error) })
    })
  }
}
